import { useMemo } from 'react';
import type { ExperimentType, UseVariantOptions } from '@cbhq/experiments';
import { useVariant } from '@cbhq/experiments';

export function useIsTreatment<T extends ExperimentType>(
  experiment: T,
  options?: UseVariantOptions<T>,
): boolean {
  const experimentGroup = useVariant(experiment, options);

  return useMemo(() => experimentGroup === 'treatment', [experimentGroup]);
}
